export const accountDisplayName = account => String(account?.name || '').trim()

export const duplicateEmailCounts = accounts => {
  const counts = new Map()
  for (const account of accounts || []) {
    const email = String(account?.emailAddress || '')
      .trim()
      .toLowerCase()
    if (!email) continue
    counts.set(email, (counts.get(email) || 0) + 1)
  }
  return counts
}

export const sharedEmailCount = (account, counts) =>
  counts.get(
    String(account?.emailAddress || '')
      .trim()
      .toLowerCase(),
  ) || 0

export const accountChoiceLabel = (account, counts) => {
  const email = String(account?.emailAddress || '').trim()
  const name = accountDisplayName(account)
  const shared = sharedEmailCount(account, counts) > 1
  if (!shared) return name ? `${name} — ${email}` : email
  const venues = Array.isArray(account?.venues) ? account.venues.length : 0
  const notes = [
    name || 'No name stored',
    email,
    account?.isAdmin ? 'OMS admin' : '',
    venues ? `${venues} venue${venues === 1 ? '' : 's'}` : 'no venues',
  ].filter(Boolean)
  return notes.join(' · ')
}
